<script>
  export let stroke = "rgb(0, 0, 0)";
</script>

<svg
  viewBox="0 0 250 250"
  width="22px"
  height="22px"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    style="fill-opacity: 0; stroke-dasharray: 12, 4; stroke: rgb(88, 87, 87); fill: none; stroke-width: 16px;"
    d="M 36.474 182.519 C 36.474 182.519 46.264 205.427 126.735 205.606 C 207.206 205.785 211.258 182.285 211.258 182.285"
    transform="matrix(-1, 0, 0, -1, 247.731995, 387.892029)"
  />
  <line
    stroke-miterlimit="10"
    x1="34.404"
    y1="210.091"
    x2="34.404"
    y2="40.012"
    id="line3"
    style="fill: none; stroke: {stroke}; stroke-miterlimit: 10; stroke-width: 16px;"
  />
  <ellipse
    stroke-miterlimit="10"
    cx="123.871"
    cy="210.091"
    rx="89.42"
    ry="28.595"
    id="ellipse9"
    style="stroke: {stroke}; stroke-miterlimit: 10; fill-opacity: 0.19; stroke-opacity: 0; fill: none; stroke-width: 16px;"
  />
  <ellipse
    stroke-miterlimit="10"
    cx="123.871"
    cy="40.012"
    rx="89.42"
    ry="28.596"
    id="ellipse11"
    style="stroke: {stroke}; stroke-miterlimit: 10; fill-opacity: 0.18; fill: none; stroke-width: 16px;"
  />
  <line
    stroke-miterlimit="10"
    x1="213.292"
    y1="210.091"
    x2="213.292"
    y2="40.012"
    id="line17"
    style="fill: none; stroke: {stroke}; stroke-miterlimit: 10; stroke-width: 16px;"
  />
  <path
    style="stroke: {stroke}; fill-opacity: 0.185; stroke-opacity: 0; fill: none; stroke-width: 16px;"
    d="M 35.404 45.26 L 34.69 206.633 C 34.69 206.633 42.544 182.96 121.14 181.662 C 199.736 180.364 213.436 206.813 213.436 206.813 L 212.991 46.426 C 212.991 46.426 194.115 67.255 126.561 68.984 C 59.007 70.714 34.83 45.594 35.404 45.26 Z"
  />
  <path
    style="stroke: {stroke}; fill-opacity: 0; fill: none; stroke-width: 16px;"
    d="M 34.585 208.782 C 34.585 208.782 36.814 238.383 123.833 237.312 C 210.852 236.241 213.399 208.831 213.399 208.831"
  />
</svg>
